import { create } from 'zustand'
import api from '../services/api'

// Shared state for the mandatory-onboarding gate. A SINGLE poller
// (MandatoryLearningGate) writes here; the rail (PrimarySidebar), the
// route guard (MandatoryLearningGate itself), and the soft banner
// (RequiredLearningGate) all read it — so we hit /learning/me/required
// once per navigation, not three times.
export interface RequiredItem {
  type: 'course' | 'quiz'
  id: string
  title: string
}

interface MandatoryLearningState {
  /** True when the current user has incomplete mandatory, visible items. */
  blocked: boolean
  items: RequiredItem[]
  /** Flips true after the first successful (or failed) fetch — until then
   *  we must NOT gate, to avoid a redirect flash before we know the answer. */
  loaded: boolean
  refresh: (serverId: string | undefined) => Promise<void>
}

export const useMandatoryLearningStore = create<MandatoryLearningState>((set) => ({
  blocked: false,
  items: [],
  loaded: false,
  refresh: async (serverId) => {
    if (!serverId) return
    try {
      const { data } = await api.get('/learning/me/required', { params: { serverId } })
      set({ items: data?.required ?? [], blocked: !!data?.blocked, loaded: true })
    } catch {
      // FAIL OPEN — a learning-module/API blip must NEVER lock the whole
      // company out of the app. Treat "unknown" as "not blocked".
      set({ blocked: false, items: [], loaded: true })
    }
  },
}))
